import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const EmailSignupModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "EmailSignupModalContainer" */
      './EmailSignupModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
